import { PopularProducts } from '@/PopularProducts';
import { Benefits } from '@/home/Benefits';
import { Collections } from '@/home/Collections';
import { Featured } from '@/home/Featured';
import { Hero } from '@/home/Hero';
import { Supercharge } from '@/home/Supercharge';
import { Testimonials } from '@/home/Testimonials';
import { HeadProps } from 'gatsby';
import { Fragment } from 'react';
import { Seo } from '../components/layout/Seo';

export default function Home() {
    return (
        <Fragment>
            <Hero />
            <Benefits />
            <PopularProducts />
            <Featured />
            <Supercharge />
            <Collections />
            <Testimonials />
        </Fragment>
    );
}

export const Head = ({ location }: HeadProps) => {
    return <Seo pathname={location.pathname.split('/').slice(-2)[0]} />;
};
